import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, OnInit } from '@angular/core';
import { I18nService } from '@core/i18n/i18n.service';
import { CentralConfigService } from '@core/services/central-config.service';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { matArrowDropDownOutline } from '@ng-icons/material-icons/outline';
import { TranslateModule } from '@ngx-translate/core';
import { UnsavedFormCheckDirective } from '@shared/directives/unsaved-form-check.directive';
import { LanguageInterface } from '@shared/interfaces/language.interface';
import { MediaBreakpoint } from '@shared/models/ui.model';
import { FormUtils } from '@shared/utils/form-utils';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  imports: [NgIcon, CommonModule, TranslateModule, UnsavedFormCheckDirective],
  viewProviders: [provideIcons({ matArrowDropDownOutline })],
})
export class LanguagesComponent implements OnInit {
  languages: LanguageInterface[];
  limit = 2;
  showAsDropdown = false;

  readonly centralConfig = inject(CentralConfigService);

  get currentLanguage(): LanguageInterface {
    return this.i18nService.language;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.showAsDropdown =
      !this.isSmallScreen() && this.languages?.length > this.limit;
  }

  constructor(private readonly i18nService: I18nService) {}

  ngOnInit(): void {
    this.getLanguages();
  }

  setLanguage(language: LanguageInterface): void {
    const destinationHref = this.getDestination(language);
    this.i18nService.language = language;

    FormUtils.navigateTo(destinationHref);
  }

  getDestination(newLanuge: LanguageInterface): string {
    const oldLanguage = this.i18nService.language?.locale;
    const newLanguage = newLanuge?.locale;
    const currentUrl = location.href;
    return currentUrl.replace(
      `/${oldLanguage?.toLowerCase()}/`,
      `/${newLanguage?.toLowerCase()}/`
    );
  }

  private getLanguages(): void {
    this.i18nService.supportedLanguages$.subscribe(items => {
      this.languages = items;
      this.showAsDropdown = !this.isSmallScreen() && items?.length > this.limit;
    });
  }

  private isSmallScreen(): boolean {
    return window.innerWidth <= MediaBreakpoint.sm;
  }
}
